var map = {
	"./01.jpg": 563,
	"./02.jpg": 564,
	"./03.jpg": 565,
	"./04.jpg": 566,
	"./05.jpg": 567,
	"./06.jpg": 568,
	"./07.jpg": 569,
	"./08.jpg": 570,
	"./09.jpg": 571,
	"./10a.jpg": 572,
	"./10b.jpg": 573,
	"./11.jpg": 574,
	"./12.jpg": 575,
	"./13.jpg": 576,
	"./16.jpg": 577,
	"./17.jpg": 578,
	"./18.jpg": 579,
	"./19.jpg": 580,
	"./20.jpg": 581,
	"./21.jpg": 582,
	"./22.jpg": 583,
	"./23.jpg": 584,
	"./24.jpg": 585,
	"./25.jpg": 586,
	"./26.jpg": 587,
	"./27.jpg": 588,
	"./28.jpg": 589,
	"./29.jpg": 590,
	"./30.jpg": 591,
	"./31.jpg": 592,
	"./32.jpg": 593,
	"./33.jpg": 594,
	"./34.jpg": 595,
	"./35.jpg": 596,
	"./36.jpg": 597,
	"./37.jpg": 598,
	"./38.jpg": 599,
	"./39.jpg": 600,
	"./40.jpg": 601,
	"./41.jpg": 602,
	"./42.jpg": 603,
	"./43.jpg": 604,
	"./44.jpg": 605,
	"./45.jpg": 606,
	"./46.jpg": 607,
	"./47.jpg": 608,
	"./48.jpg": 609,
	"./49.jpg": 610,
	"./50.jpg": 611,
	"./51.jpg": 612,
	"./52.jpg": 613,
	"./53.jpg": 614,
	"./54.jpg": 615,
	"./55.jpg": 616,
	"./56.jpg": 617,
	"./57.jpg": 618,
	"./58.jpg": 619,
	"./60.jpg": 620,
	"./61.jpg": 621,
	"./62.jpg": 622,
	"./63.jpg": 623,
	"./64.jpg": 624,
	"./65.jpg": 625,
	"./66.jpg": 626,
	"./67.jpg": 627,
	"./69.jpg": 628,
	"./70.jpg": 629,
	"./71.jpg": 630,
	"./72.jpg": 631,
	"./73.jpg": 632,
	"./75.jpg": 633,
	"./76.jpg": 634
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 562;


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished nonrecursive \.(png|jpe?g|svg)$
// module id = 562
// module chunks = 0